import moment from 'moment';

const MIN_DATE = moment('2021-07-25').valueOf();
const ONE_DAY = moment.duration(1, 'day').valueOf();

export const CERTIFICATE_TYPE = {
  FIFTY_CALLS: 'FIFTY_CALLS',
  DAILY_SUMMARY: 'DAILY_SUMMARY',
};

export class CertificateCursor {
  constructor(date, type) {
    if (typeof date !== 'number') throw new RangeError('invalid date');
    if (moment(date).startOf('day').valueOf() !== date) throw new RangeError('invalid date');
    if (!Object.values(CERTIFICATE_TYPE).includes(type)) throw new RangeError('invalid type');
    this.date = date;
    this.type = type;
  }

  prev() {
    switch (this.type) {
      case CERTIFICATE_TYPE.FIFTY_CALLS:
        return this.date > MIN_DATE ? new CertificateCursor(this.date - ONE_DAY, CERTIFICATE_TYPE.DAILY_SUMMARY) : null;
      case CERTIFICATE_TYPE.DAILY_SUMMARY:
        return new CertificateCursor(this.date, CERTIFICATE_TYPE.FIFTY_CALLS);
      default:
        throw new RangeError('invalid type');
    }
  }

  next() {
    switch (this.type) {
      case CERTIFICATE_TYPE.FIFTY_CALLS:
        return new CertificateCursor(this.date, CERTIFICATE_TYPE.DAILY_SUMMARY);
      case CERTIFICATE_TYPE.DAILY_SUMMARY:
        return this.date + ONE_DAY < Date.now()
          ? new CertificateCursor(this.date + ONE_DAY, CERTIFICATE_TYPE.FIFTY_CALLS)
          : null;
      default:
        throw new RangeError('invalid type');
    }
  }
}
